import { initializeTracking } from '@elevenia/edts-tracker';
import React from 'react';
import { Card, CardBody, CardGroup, CardImg, CardSubtitle, CardText, CardTitle, Button } from 'reactstrap';

const CardNavigate = ({ array }) => {
    const handleClick = async () => {
        try {
            await initializeTracking({
                types: "page_view_web",
                newSources: {
                    "core": {
                        "event_name": "page_view",
                        "event_timestamp": "1654589080",
                        "page_name": "tes", "page_urlpath": "http:tes.com",
                        "previous_page": "Home",
                        "previous_page_urlpath": ""
                    },
                    "user": {
                        "session_id": "7d32c247-b8aa-4c35-bfc9-98062ddcff81-1632455965352",
                        "user_id": "999"
                    },
                    "application": {
                        "source_name": "web",
                        "os_name": "Windows",
                        "os_version": "Windows version",
                        "browser_name": "Chrome 95"
                    },
                    "marketing": {
                        "utm_raw": "https://www.klikindomaret.com/product/body-scent-spray-cologne?utm_source=facebook&utm_medium=banner&utm_campaign=product_kecantikan_20220323&utm_id=12345&utm_term=running&utm_content=product_kecantikan"
                    }
                },
                url: "https://klikidm-apps-tracker-gateway-45cx4ebp.uc.gateway.dev/apps-tracker-gateway",
                reqParams: {
                    "x-api-key": "AIzaSyAupTMnsywgUeZh0QAVf68DdK4fAdpiTv8",
                    'Content-Type': 'application/json',
                }
            })
        } catch (e) {
            console.log(e.data)
        }
    }
    return (
        <CardGroup>
            {
                array.map((item, index) => (
                    <Card key={index} style={{ border: "1px solid #6c757d", margin: 8 }}>
                        <CardImg
                            alt="Card image cap"
                            src={item}
                            top
                            width="100%"
                            height="150"
                        />
                        <CardBody>
                            <CardTitle tag="h5">
                                Card title
                            </CardTitle>
                            <CardSubtitle
                                className="mb-2 text-muted"
                                tag="h6"
                            >
                                Card subtitle
                            </CardSubtitle>
                            <CardText>
                                This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.
                            </CardText>
                            <Button style={{ fontWeight: "bold" }} color='primary' onClick={() => { handleClick() }}>
                                Click Link Web
                            </Button>
                        </CardBody>
                    </Card>
                ))
            }
        </CardGroup >
    )
}

export default CardNavigate